import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_api/hello')({
  component: HelloRoute,
})

function HelloRoute() {
  return <p>Hello from static mode.</p>
}
